
import { Policy } from "@/types";

// Core policies for demo
export const corePolicies: Policy[] = [
  {
    id: "1",
    title: "Privacy Policy",
    description: "Our company's privacy policy regarding user data",
    content: "This privacy policy outlines how our company collects, uses, and safeguards your personal information. We are committed to protecting your privacy and handling your data with transparency. This policy explains what information we collect, how we use it, and your rights regarding your data.\n\nInformation We Collect: We collect personal information such as your name, email address, and other contact details when you register for an account. We may also collect usage data and cookies to improve our services.\n\nHow We Use Your Information: Your information helps us provide and improve our services, communicate with you, and ensure security of our platform.\n\nData Security: We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.",
    createdAt: "2023-01-15T10:30:00Z",
    updatedAt: "2023-01-15T10:30:00Z",
    reviewDate: "2023-05-15T00:00:00Z", // Past review date for testing
    ownerId: "1",
    requiredUserTypes: ["admin", "doctor", "nurse"],
    version: "1.0",
    isReviewOverdue: true,
    editLog: [
      {
        editedBy: "Dr. Emma Taylor",
        timestamp: "2022-11-05T09:15:00Z",
        changes: "Initial policy creation"
      },
      {
        editedBy: "John Doe",
        timestamp: "2022-12-10T14:30:00Z",
        changes: "Updated data security section"
      }
    ],
    reviews: [
      {
        reviewedBy: "Dr. Emma Taylor",
        timestamp: "2022-11-05T09:15:00Z"
      },
      {
        reviewedBy: "John Doe",
        timestamp: "2023-01-15T10:30:00Z"
      }
    ],
    previousVersions: [
      {
        version: "0.8",
        content: "This privacy policy outlines how our company collects and uses your personal information. We are committed to protecting your privacy.\n\nInformation We Collect: We collect basic personal information such as your name and email address when you register.\n\nHow We Use Your Information: Your information helps us provide our services.\n\nData Security: We take basic measures to protect your data.",
        updatedAt: "2022-11-05T09:15:00Z"
      },
      {
        version: "0.9",
        content: "This privacy policy outlines how our company collects and uses your personal information. We are committed to protecting your privacy and handling your data responsibly.\n\nInformation We Collect: We collect personal information such as your name, email address when you register for an account.\n\nHow We Use Your Information: Your information helps us provide our services and communicate with you.\n\nData Security: We implement security measures to protect your personal information.",
        updatedAt: "2022-12-10T14:30:00Z"
      }
    ]
  },
  {
    id: "2",
    title: "Terms of Service",
    description: "Terms and conditions for using our services",
    content: "These Terms of Service (\"Terms\") govern your access to and use of our services, including our website, emails, and applications (the \"Services\"). By accessing or using our Services, you agree to be bound by these Terms.\n\nAccount Registration: When you create an account with us, you must provide accurate information and keep your credentials secure. You are responsible for all activity that occurs under your account.\n\nProhibited Conduct: You agree not to misuse our Services or help anyone else do so. This includes violating these Terms, attempting to access our systems without authorization, or using our Services for any illegal purpose.\n\nContent and Intellectual Property: Our Services and content within them are protected by intellectual property rights. You may not use our content without permission.",
    createdAt: "2023-01-15T11:45:00Z",
    updatedAt: "2023-04-20T09:15:00Z",
    reviewDate: "2025-05-19T00:00:00Z",
    ownerId: "2",
    requiredUserTypes: ["admin", "doctor", "nurse", "student"],
    version: "1.2",
    isReviewOverdue: false,
    editLog: [
      {
        editedBy: "Jane Smith",
        timestamp: "2023-01-15T11:45:00Z",
        changes: "Initial terms creation"
      },
      {
        editedBy: "Dr. Emma Taylor",
        timestamp: "2023-02-25T13:20:00Z",
        changes: "Updated account registration requirements"
      },
      {
        editedBy: "Michael Johnson",
        timestamp: "2023-04-20T09:15:00Z",
        changes: "Added intellectual property protections"
      }
    ],
    reviews: [
      {
        reviewedBy: "Jane Smith",
        timestamp: "2023-01-15T11:45:00Z"
      },
      {
        reviewedBy: "Dr. Emma Taylor",
        timestamp: "2023-04-20T09:15:00Z"
      }
    ],
    previousVersions: [
      {
        version: "1.0",
        content: "These Terms of Service govern your access to and use of our services. By accessing our Services, you agree to be bound by these Terms.\n\nAccount Registration: When you create an account with us, you must provide accurate information.\n\nProhibited Conduct: You agree not to misuse our Services.\n\nContent: Our Services and content are protected by law.",
        updatedAt: "2023-01-15T11:45:00Z"
      },
      {
        version: "1.1",
        content: "These Terms of Service govern your access to and use of our services, including our website and applications. By accessing our Services, you agree to be bound by these Terms.\n\nAccount Registration: When you create an account with us, you must provide accurate information and keep your credentials secure. You are responsible for all activity under your account.\n\nProhibited Conduct: You agree not to misuse our Services or help anyone else do so. This includes violating these Terms or using our Services for illegal purposes.\n\nContent: Our Services and content are protected by law. You may not use our content without permission.",
        updatedAt: "2023-02-25T13:20:00Z"
      }
    ]
  }
];
